import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { ExpositionConsumerMappingEntity } from '../../domain/exposition-consumer-mapping.entity';
import { ExpositionConsumerMappingListEntity } from './exposition-consumers-mapping-list.entity';

@Injectable()
export class ExpositionConsumersMappingListProvider {
	private readonly consumersMappingList: ExpositionConsumerMappingListEntity;

	public constructor() {
		this.consumersMappingList = ExpositionConsumerMappingListEntity.build([
			{
				field: 'isGroup',
				alias: $localize`:i18n=@@expositions.consumers.mapping.list.column.type:`,
				type: 'string',
				isSearchable: false,
				isFilterable: false,
				hasHeaderFilter: true,
				canBeReordered: true,
				visible: true,
				visibleIndex: 0,
				width: '4%',
			},
			{
				field: 'fullName',
				alias: $localize`:i18n=@@expositions.consumers.mapping.list.column.sourceMember:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: false,
				canBeReordered: true,
				visible: true,
				visibleIndex: 1,
				width: '10%',
			},
			{
				field: 'targetConsumers',
				alias: $localize`:i18n=@@expositions.consumers.mapping.list.column.targetMember:`,
				type: '',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				canBeReordered: false,
				visible: true,
				visibleIndex: 2,
				width: '86%',
			},
		]);
	}

	public getList(): ExpositionConsumerMappingListEntity {
		return this.consumersMappingList;
	}

	public setListElements(
		elements: Map<string, ExpositionConsumerMappingEntity>
	): ExpositionConsumerMappingListEntity {
		return this.consumersMappingList.setElements(elements);
	}
}
